import { useEffect, useState } from "react";

import { datadogRum } from "@datadog/browser-rum";
// import { useAuth } from "@eco/stratos-auth";
import { getEnv } from "../utils/get-env";

const Datadog = () => {
  //   const { user, roles } = useAuth();

  const [hasInitialized, setHasInitialized] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    datadogRum.init({
      applicationId: getEnv("NEXT_PUBLIC_DATADOG_APPLICATION_ID"),
      clientToken: getEnv("NEXT_PUBLIC_DATADOG_CLIENT_TOKEN"),
      site: getEnv("NEXT_PUBLIC_DATADOG_URL"),
      service: "dtn-eco-documentation",
      env: getEnv("ENV"),
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      sampleRate: 100,
      premiumSampleRate: 10,
      trackInteractions: true,
      defaultPrivacyLevel: "mask-user-input",
    });

    setHasInitialized(true);
    datadogRum.startSessionReplayRecording();
  }, []);

  //   useEffect(() => {
  //     if (!hasInitialized) {
  //       return;
  //     }

  //     if (user === undefined) {
  //       datadogRum.removeUser();
  //       datadogRum.stopSessionReplayRecording();
  //       return;
  //     }

  //     if (roles.length === 0) {
  //       return;
  //     }

  //     datadogRum.setUser({
  //       id: user.id,
  //       name: currentUser.name,
  //       email: user.email,
  //       customerId: user.customerId?.join(", "),
  //       roles: roles.join(", "),
  //     });
  //     datadogRum.startSessionReplayRecording();
  //   }, [user, currentUser, hasInitialized]);

  return <></>;
};

export default Datadog;
